import { makeRoute } from "@flow/common/route";
import * as Safe from "safe-portals";
import { Serializers } from "@flow/common/types";
import * as perm from "@flow/common/core_permissions";

export const getSettings = makeRoute(
  "/admin/api/survey/get_settings",
  [perm.VIEW_SETTINGS],
  Safe.nothing,
  Safe.obj({
    consent_config_guids: Safe.optional(Safe.array(Safe.str)),
  })
);

export const setSettings = makeRoute(
  "/admin/api/survey/set_settings",
  [perm.UPDATE_SETTINGS],
  Safe.obj({
    consent_config_guids: Safe.optional(Safe.array(Safe.str)),
  }),
  Safe.nothing
);

export const storeSingleAnswer = makeRoute(
  "/api/plugin/survey/store_single_answer",
  "public",
  Safe.obj({
    context: Serializers.journeyContext,
    actionGuid: Safe.str,
    consents: Safe.array(Serializers.consent),
    answer: Serializers.crmSurveyResponse,
  }),
  Safe.nothing
);
